import { PaintedScene } from '../PaintedScene';

export const HILL_PATH_MID_PHASER_KEY = 'HillPathMidScene' as const;
export const HILL_PATH_MID_MANIFEST_KEY = 's-502-hill-path-mid' as const;

export class HillPathMidScene extends PaintedScene {
  constructor() {
    super(HILL_PATH_MID_PHASER_KEY, HILL_PATH_MID_MANIFEST_KEY);
  }
}
